import './LeftNav.css';
import { useSelector, useDispatch } from "react-redux";
import { setSupplementary } from "../Store/LoadReducer";
import { formatInputNumber } from "../../helpers/utils";

function PINNSupplementary() {
    const supplementary = useSelector(item => item.flowviewer.supplementary);
    const dispatch = useDispatch();


    const toggleBlock = (event) => {
        const targetBlock = event.target.parentElement;
        targetBlock.classList.toggle('active', !targetBlock.classList.contains('active'));
    }

    function validateSupplementary(name, value) {
        const floatValidator = (v) => {
            v = v.replace('.', ',');
            return {
                result: (v == "" || /^\d+,?\d*$/.test(v)),
                value: v
            }
        }
        const integerValidator = (v) => {
            return {
                result: (v == "" || /^-?\d+$/.test(v)),
                value: v
            }
        }
        const booleanValidator = (v) => {
            return {
                result: (v == "" || v === "1" || v === "0"),
                value: v
            };
        }

        const validator = {
            tobacco_abuse: booleanValidator,
            diabetes: booleanValidator,
            hypertension: booleanValidator,
            previous_mi_history: booleanValidator,
            previous_pci: booleanValidator,
            density: floatValidator,
            viscosity: floatValidator,
            p0: floatValidator,
            elasticity: floatValidator,
            windkessel_c: floatValidator,
            windkessel_r1: floatValidator,
            windkessel_r2: floatValidator,
            hyperemia: booleanValidator,
            myocardium_mass_multiplier: floatValidator,
            murrey_exponent: floatValidator,
        };
        if (validator.hasOwnProperty(name)) {
            return validator[name](value);
        } else {
            return {
                result: true,
                value: value
            }
        }
    }

    const onChangeSupplementary = (e, name) => {
        const validationResult = validateSupplementary(name, e.target.value);
        if (validationResult.result) {
            dispatch(setSupplementary({
                name: name,
                value: validationResult.value,
                modelType: "pinn"
            }));
        }
    };

    return (
        <div>
            <div className="nav-block">
                <div className="title-nav-clickable title-nav mt-2 mb-2" onClick={toggleBlock}>
                    Supplementary
                </div>
                <div className="nav-block-content">
                    {[
                        { name: "tobacco_abuse", label: "Tobacco abuse" },
                        { name: "diabetes", label: "Diabetes" },
                        { name: "hypertension", label: "Hypertension" },
                        { name: "previous_pci", label: "Previous PCI" },
                        { name: "previous_mi_history", label: "Previous MI history" },
                    ].map(({ name, label }) => (
                        <div key={name} className="d-flex align-items-center text-white mb-2">
                            <p className="mb-0 title-meas">{label}</p>
                            <div className="d-flex gap-2">
                                <label className="d-flex align-items-center gap-1" style={{whiteSpace: "nowrap"}}>
                                    <input type="radio" name={name} value="1"
                                        onChange={(e) => onChangeSupplementary(e, name)}
                                        checked={supplementary["pinn"][name] == 1} />
                                    Yes
                                </label>
                                <label className="d-flex align-items-center gap-1" style={{whiteSpace: "nowrap"}}>
                                    <input type="radio" name={name} value="0"
                                        onChange={(e) => onChangeSupplementary(e, name)}
                                        checked={supplementary["pinn"][name] !== "" && supplementary["pinn"][name] == 0} />
                                    No
                                </label>
                                <label className="d-flex align-items-center gap-1" style={{whiteSpace: "nowrap"}}>
                                    <input type="radio" name={name} value=""
                                        onChange={(e) => onChangeSupplementary(e, name)}
                                        checked={supplementary["pinn"][name] === ""} />
                                    N/A
                                </label>
                            </div>
                        </div>
                    ))}

                    <hr className="text-white"/>

                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Windkessel C</p>
                        <input onChange={(e) => onChangeSupplementary(e, "windkessel_c")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("windkessel_c") ? formatInputNumber(supplementary["pinn"].windkessel_c) : ""} />
                        <p className="mb-0 nav-block-unit">cm<sup>4</sup>*s<sup>2</sup>/g</p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Windkessel R1</p>
                        <input onChange={(e) => onChangeSupplementary(e, "windkessel_r1")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("windkessel_r1") ? formatInputNumber(supplementary["pinn"].windkessel_r1) : ""} />
                        <p className="mb-0 nav-block-unit">g/s/cm<sup>4</sup></p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Windkessel R2</p>
                        <input onChange={(e) => onChangeSupplementary(e, "windkessel_r2")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("windkessel_r2") ? formatInputNumber(supplementary["pinn"].windkessel_r2) : ""} />
                        <p className="mb-0 nav-block-unit">g/s/cm<sup>4</sup></p>
                    </div>

                    <hr className="text-white"/>

                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Elasticity</p>
                        <input onChange={(e) => onChangeSupplementary(e, "elasticity")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("elasticity") ? formatInputNumber(supplementary["pinn"].elasticity) : ""} />
                        <p className="mb-0 nav-block-unit">Pa</p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Density</p>
                        <input onChange={(e) => onChangeSupplementary(e, "density")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("density") ? formatInputNumber(supplementary["pinn"].density) : ""} />
                        <p className="mb-0 nav-block-unit">g/cm<sup>3</sup></p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <label htmlFor="hyperemia">
                            <p className="mb-0 title-meas" style={{ width: "115px" }}>Hyperemia</p>
                        </label>
                        <input id="hyperemia"
                            className="advanced-mode-checkbox"
                            onChange={(e) => onChangeSupplementary(e, "hyperemia")}
                            checked={supplementary["pinn"].hyperemia == 1 ? "checked" : ""}
                            type="checkbox"
                            value={supplementary["pinn"].hyperemia == 1 ? 0 : 1}
                        />
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">P0</p>
                        <input onChange={(e) => onChangeSupplementary(e, "p0")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("p0") ? formatInputNumber(supplementary["pinn"].p0) : ""} />
                        <p className="mb-0 nav-block-unit">Pa</p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Viscosity</p>
                        <input onChange={(e) => onChangeSupplementary(e, "viscosity")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("viscosity") ? formatInputNumber(supplementary["pinn"].viscosity) : ""} />
                        <p className="mb-0 nav-block-unit">cm<sup>2</sup>/s</p>
                    </div>
                    <hr className="text-white"/>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Murrey exponent</p>
                        <input onChange={(e) => onChangeSupplementary(e, "murrey_exponent")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("murrey_exponent") ? formatInputNumber(supplementary["pinn"].murrey_exponent) : ""} />
                        <p className="mb-0 nav-block-unit"></p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Myocardium mass multiplier</p>
                        <input onChange={(e) => onChangeSupplementary(e, "myocardium_mass_multiplier")}
                            className="input-measurements me-2"
                            type="text"
                            value={supplementary["pinn"].hasOwnProperty("myocardium_mass_multiplier") ? formatInputNumber(supplementary["pinn"].myocardium_mass_multiplier) : ""} />
                        <p className="mb-0 nav-block-unit"></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PINNSupplementary;